// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","BlogsPopularFeed":"jw_a bhc_qr bhc_a bhc_w","BlogsPopularFeed__loading":"jw_b"};